import { render } from "./account_info.vue?vue&type=template&id=32c84171&scoped=true"
import script from "./account_info.vue?vue&type=script&lang=js"
export * from "./account_info.vue?vue&type=script&lang=js"

import "./account_info.vue?vue&type=style&index=0&id=32c84171&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c84171"]])

export default __exports__